import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetColorPaletteDto from "./dto/get-color-palette.dto";
import type UpdateColorDto from "./dto/update-color.dto";
import type DeleteColorDto from "./dto/delete-custom-color.dto";

export const ColorPaletteEffectActions = {
  getColorPalette: `${Entities.ColorPalette}_getColorPalette`,
  updateCustomColor: `${Entities.ColorPalette}_updateCustomColor`,
  deleteCustomColor: `${Entities.ColorPalette}_deleteCustomColor`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.ColorPalette,
  initSchema,
  aliasName: DIContainerKeys.ColorPaletteService,
})
export class ColorPaletteService extends HttpService {
  @loader(Loaders.GetColorPaletteLoader)
  @action(DIContainerKeys.ColorPaletteService)
  public *getColorPalette(dto: GetColorPaletteDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetColorPaletteLoader, true);
    const response = yield call(
      this.get,
      {
        url: BASE_API_PATHS.getColorPalette,
        domain: API_DOMENS.PSA_API,
        params: {
          onjid_Customer: dto.clientId,
        }
      },
      ReducerMethods.UPDATE
    );
    if (!response?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetColorPaletteLoader, false);
      return;
    }
    const payload = response?.Data?.reduce((acc: any, curr: any) => {
      acc[curr.Id] = curr;
      return acc;
    }, {});
    yield this.setEntityStateById(Entities.ColorPalette, dto.clientId, payload);
    yield this.setLoaderState(Loaders.GetColorPaletteLoader, false);
  }

  @loader(Loaders.UpdateCustomColorLoader)
  @action(DIContainerKeys.ColorPaletteService)
  public *updateCustomColor(dto: UpdateColorDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.UpdateCustomColorLoader, true);
    yield call(
      this.post,
      {
        url: BASE_API_PATHS.createEditCustomColor,
        domain: API_DOMENS.PSA_API,
        params: {
          customerId: dto.clientId,
          HexCode: dto.HexCode,
        },
      },
      ReducerMethods.UPDATE
    );
    yield this.setLoaderState(Loaders.UpdateCustomColorLoader, false);
    yield this.getColorPalette({ clientId: dto.clientId });
  }

  @loader(Loaders.DeleteCustomColorLoader)
  @action(DIContainerKeys.ColorPaletteService)
  public *deleteCustomColor(dto: DeleteColorDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.DeleteCustomColorLoader, true);
    const response = yield call(
      this.post,
      {
        url: BASE_API_PATHS.deleteCustomColor,
        domain: API_DOMENS.PSA_API,
        params: {
          id: dto.colorId,
          objId_Customer: dto.clientId,
        },
        body: {}
      },
      ReducerMethods.UPDATE
    );
    if (!response?.Data?.Success) {
      CallToast(response?.Data?.Message, false, false, "v2style");
      yield this.setLoaderState(Loaders.DeleteCustomColorLoader, false);
      return;
    }
    yield this.setLoaderState(Loaders.DeleteCustomColorLoader, false);
    yield this.getColorPalette({ clientId: dto.clientId });
  }
}